import CityLinks from '@/components/CityLinks'
import Hero from '@/components/Hero'
import { getBlogs, getBlogBySlug, getCities } from '@/lib/data'
import { GetStaticPaths, GetStaticProps } from 'next'
import Head from 'next/head'

export default function BlogDetail({ cities,blog }: any) {
  if (!blog) return <div className="container mx-auto p-8">Beitrag nicht gefunden</div>
  const title= blog.title + " | Autoverwertung Blog";
  return (
    <div>
            <Head>
        <title>{title}</title>
        <meta name="description" content={blog.excerpt || blog.title} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={blog.excerpt || blog.title} />
        <meta property="og:image" content={blog.image || '/logo.jpeg'} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`https://autoverwertungs.de/blogs/${blog.slug}`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${blog.title} | Autoverwertung Blog`} />
        <meta name="twitter:description" content={blog.excerpt || blog.title} 
        />
        <meta name="twitter:image" content={blog.image || '/logo.jpeg'} />
        <meta name="robots" content="index, follow" />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BlogPosting',
          'headline': blog.title,
          'image': blog.image || '/logo.jpeg',
          'author': {
            '@type': 'Person',
            'name': blog.author || 'Autoverwertung Redaktion'
          },
          'description': blog.excerpt || blog.title,
          'articleBody': blog.contentHtml,
          'url': `https://autoverwertungs.de/blogs/${blog.slug}`
        }) }} />
      </Head>
      <Hero city={` Blog | ${blog.title} `} />
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-3xl font-bold">{blog.title}</h2>
        <p className="text-sm text-gray-600">von {blog.author}</p>
        {blog.image && <img src={blog.image} alt={blog.title} className="w-full h-64 object-cover my-4" />}
        <div className="prose" dangerouslySetInnerHTML={{ __html: blog.contentHtml }} />
     <div className='mt-2'>
     <CityLinks cities={cities} />
     </div>
      </div>
 
    </div>
  )
}

export const getStaticPaths: GetStaticPaths = async () => {
  const blogs = await getBlogs()

  const paths = blogs.map((b: any) => ({ params: { slug: b.slug } }))
  return { paths, fallback: false }
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = params?.slug as string
  const cities = await getCities()
  const blog = await getBlogBySlug(slug)

  return { props: { cities,blog } }
}
